import {
  GetServerSideProps,
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  NextPage,
} from "next";

import getTerms from "api/requests/wordpress/getTerms";
import { MenuItems, Term } from "custom-types/Wordpress";
import { getCountryCodeHeader } from "utils/requestContext";

import CannabisGlossaryTermLayout from "components/news/Layouts/CannabisGlossaryTermLayout";

type Props = {
  menuItems: MenuItems;
  term: Term;
  currentLetter: string;
};

const CannabisGlossaryTermPage: NextPage<Props> = (props) => {
  return <CannabisGlossaryTermLayout {...props} />;
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<Props>> => {
  const { params } = context;

  if (!params?.termSlug || typeof params.termSlug !== "string") {
    return {
      notFound: true,
    };
  }

  const countryCode = getCountryCodeHeader(context.req.headers);

  const firstCharacterOfSlug = params.termSlug.charAt(0);
  const firstLetterOfTerm = firstCharacterOfSlug.match(/[a-z]/i)
    ? firstCharacterOfSlug
    : "special";
  const termsResponse = await getTerms(countryCode, {
    term_letter: firstLetterOfTerm,
  });

  const term = termsResponse.find((term) => term.slug === params.termSlug);

  if (!term) {
    return {
      notFound: true,
    };
  }

  const menuItems = termsResponse.map((term) => ({
    slug: term.slug,
    title: term.title,
    url: term.link,
  }));

  return {
    props: {
      currentLetter: firstLetterOfTerm,
      menuItems,
      term,
    },
  };
};

export default CannabisGlossaryTermPage;
